<template>
    <div>
        <report-header
            :title="title"
            :isLoading="isLoading"
            :reportPagination="pagination"
            :isShowDateRange="true"
            :formatDateRangeTitle="dateRange"
        />
        <b-card id="report-card">
            <div id="report-body" class="w-100">
                <div v-if="isInitialLoad" class="w-100 pt-2 pb-2">
                    <i
                        >Please select the
                        <a @click="openFilterModal" class="text-link">filter</a>
                    </i>
                </div>
                <template v-else>
                    <div>
                        <p class="item-name">
                            Summary
                        </p>
                        <QTable
                            :data="summaryData"
                            :columns="summaryHeader"
                            :loading="loading.summary"
                            :rows-per-page-options="[0]"
                            hide-bottom
                            class="mb-4"
                        >
                            <template v-slot:bottom-row>
                                <q-tr v-if="loading.summary">
                                    <q-td colspan="2"
                                        >Loading summary...
                                        {{ dataLoadedString }}</q-td
                                    >
                                </q-tr>
                                <q-tr
                                    v-else-if="
                                        !loading.summary &&
                                        !isInitialLoad &&
                                        !isError &&
                                        summaryData.length === 0
                                    "
                                >
                                    <q-td colspan="2"
                                        >No records available</q-td
                                    >
                                </q-tr>
                            </template>
                        </QTable>
                    </div>

                    <p class="item-name">
                        Details
                    </p>
                    <QTable
                        :columns="listHeader"
                        :data="resultLists"
                        hide-bottom
                        :loading="loading.details"
                        :rows-per-page-options="[0]"
                    >
                        <template v-slot:bottom-row>
                            <q-tr v-if="loading.details">
                                <q-td colspan="7"
                                    >Loading details...
                                    {{ dataLoadedString }}</q-td
                                >
                            </q-tr>
                            <q-tr
                                v-else-if="
                                    !loading.details &&
                                    !isInitialLoad &&
                                    !isError &&
                                    resultLists.length === 0
                                "
                            >
                                <q-td colspan="7">No records available</q-td>
                            </q-tr>
                        </template>
                        <template v-slot:body-cell-invoice="props">
                            <q-td :props="props">
                                <InvoiceLink
                                    v-if="
                                        props.row.invoice &&
                                        props.row.invoice.encoded_id
                                    "
                                    :invoice="props.row.invoice"
                                />
                            </q-td>
                        </template>
                        <template v-slot:body-cell-client="props">
                            <q-td :props="props">
                                <client-name
                                    v-if="props.row.client"
                                    :client="props.row.client"
                                />
                            </q-td>
                        </template>
                    </QTable>
                </template>
            </div>
        </b-card>
    </div>
</template>

<script>
import { QTable } from "quasar";
import Report from "@/mixins/report.js";
import ReportService from "@/services/report";
import CREPORT from "@/constants/report";
import "@/css/quasar-table.css";
import { isEmpty } from "lodash";
export default {
    mixins: [Report],
    components: {
        QTable,
        ReportHeader: () => import("@/components/report/report-header"),
        InvoiceLink: () => import("@/components/commons/invoice-link"),
        ClientName: () => import("@/components/commons/client-name")
    },
    props: {
        data: {
            type: Object,
            default() {
                return {
                    start: this.getStartDate("month"),
                    end: this.getEndDate("day")
                };
            }
        }
    },
    data() {
        return {
            summaryData: [],
            resultLists: [],
            title: "Total Write Offs",
            dateRange: "",
            isInitialLoad: true,
            isError: false,
            indexAxios: 0,
            abortController: [],
            loading: {
                summary: false,
                details: false
            }
        };
    },
    mounted() {
        let self = this;
        self.data.reportId = CREPORT.TYPE.WRITE_OFFS;
        self.data.filterDateOption = true;
        self.data.isShowDateRange = true;
        self.data.datePickerOptionDefault = 3;

        self._getSetting().then(() => {
            self.data.start = self.getStartDate("month");
            self.data.end = self.getEndDate("day");
            self.data.from = self.converToUnix(self.data.start);
            self.data.to = self.converToUnix(self.data.end);
            self.data.writeOffsMin = null;
            self.data.writeOffsMax = null;
            self.togglehideActions(true);
            self.openFilterModal();
        });

        self.$root.$on("report-filter-date-range:refresh", self.prepareData); // When click refresh and filter button on filter modal
        window.scrollTo(0, 0);
    },
    beforeDestroy: function () {
        this.data.isShowDateTimeRange = false;
        this.data.datePickerOptionDefault = null;
        this.data.reportId = null;
        this.data.writeOffsMin = null;
        this.data.writeOffsMax = null;
        this.$root.$off("report-filter-date-range:refresh", this.prepareData);
        if (this.abortController.length > 0) {
            this.abortController[this.indexAxios].abort();
        }
    },
    methods: {
        handleError(indexAxios, error) {
            if (!this.abortController[indexAxios].signal.aborted) {
                console.error(error.message);
                this.loading.summary = false;
                this.loading.details = false;
                this.loadingCompleted();
                this.togglehideActions(false);
                this.isError = true;
                this._message("Error: Unable to get the report", "danger");
            }
        },
        prepareData(params) {
            let isRefresh = 0;
            console.log(params);
            if (this.abortController.length > 0) {
                this.abortController[this.indexAxios].abort();
            }
            if (params) {
                this.data.from = params.from;
                this.data.to = params.to;
                this.data.writeOffsMin = params.writeOffsMin;
                this.data.writeOffsMax = params.writeOffsMax;
            } else {
                // Refresh
                isRefresh = 1;
            }
            this.indexAxios++;
            this.resultLists = [];
            this.resetPagination();
            this.init(this.indexAxios, isRefresh);
        },
        async init(indexAxios, isRefresh = 0) {
            let self = this;

            // Reset all state
            self.isError = false;
            self.isInitialLoad = false;
            self.loading.summary = true;
            self.loading.details = true;
            self.abortController[indexAxios] = new AbortController();

            // Reset all params and data
            self.pagination.page = 1;
            self.pagination.lastPage = 1; // Last page will be updated in first API
            self.resultLists = [];
            self.summaryData = [];

            // Set title and date range
            self.dateRange = self.getDateRange(self.data.from, self.data.to);
            self.dynamicPageTitle(self.title);

            this.togglehideActions(true);
            self.loadingPercentages();

            let tempWriteOffs = [];
            const isPageFirst = this.pagination.page === 1;
            let params = {
                from: self.data.from,
                to: self.data.to,
                perPage: this.RECORD_PER_PAGE,
                refresh: isRefresh,
                signal: self.abortController[indexAxios].signal,
                show_results: false,
                amount_min: this.data.writeOffsMin,
                amount_max: this.data.writeOffsMax
            };

            while (self.pagination.page <= self.pagination.lastPage) {
                self.loadingPercentages();
                try {
                    params.page = self.pagination.page;
                    let res = await ReportService.getReport(
                        CREPORT.TYPE.WRITE_OFFS,
                        params
                    );

                    if (res && res.message && res.message.code === 200) {
                        if (isPageFirst && !isEmpty(res.resource.summary)) {
                            self.summaryData = [res.resource.summary];
                            self.loading.summary = false;
                        }

                        if (
                            res.resource?.details?.data &&
                            !isEmpty(res.resource.details.data)
                        ) {
                            tempWriteOffs = tempWriteOffs.concat(
                                res.resource.details.data
                            );
                        }
                        if (res.resource?.meta && isPageFirst) {
                            self.pagination.lastPage =
                                res.resource.details.last_page;

                            self.title = res.resource.meta.title;
                            self.dynamicPageTitle(self.title);
                        }
                    } else {
                        throw new Error("Error: Unable to get the report.");
                    }
                    self.pagination.page++;
                } catch (e) {
                    this.handleError(indexAxios, e);
                    break;
                }
            }

            if (!this.isError) {
                self.resultLists = tempWriteOffs;
            }
            self.loadingCompleted();
            self.timer(1000).then(() => {
                self.togglehideActions(false);
                self.loading.details = false;
                self.loading.summary = false;
            });
        },
        togglehideActions(value) {
            this.defaultToggleHideActions(value);
        }
    },
    computed: {
        dataLoadedString() {
            return `(${this.pagination.current}%)`;
        },
        summaryHeader() {
            return [
                {
                    name: "total_count",
                    field: "total_count",
                    label: "Total Count",
                    align: "left",
                    style: "vertical-align: top"
                },
                {
                    name: "total_amount",
                    field: "total_amount",
                    label: "Total Amount",
                    align: "left",
                    style: "vertical-align: top",
                    format: (val, row) => {
                        let value = val || 0;
                        return this._toCurrency(value);
                    }
                }
            ];
        },
        listHeader() {
            return [
                {
                    name: "invoice",
                    label: "Invoice",
                    style: "width:10%;min-width:115px",
                    align: "left"
                },
                {
                    name: "invoice_date",
                    label: "Invoice Date",
                    style: "width:10%",
                    field: "invoice_date",
                    align: "left",
                    format: (val, row) => {
                        if (row?.invoice?.start) {
                            return this._carbonDateDisplay(row.invoice.start);
                        }
                        return "--";
                    }
                },
                {
                    name: "client",
                    label: "Client",
                    style: "width: 15%;min-width:115px",
                    align: "left"
                },
                {
                    name: "writeoff_amount",
                    label: "Write Off Amount",
                    style: "width: 10%;min-width:150px",
                    align: "left",
                    field: "amount",
                    format: (val, row) => {
                        return this._toCurrency(val);
                    }
                },
                {
                    name: "writeoff_date",
                    label: "Write Off Date",
                    style: "width: 10%;min-width:150px",
                    align: "left",
                    format: (val, row) => {
                        if (row?.writeoff_date) {
                            return this._carbonDateDisplay(row.writeoff_date);
                        }
                        return "-";
                    }
                },
                {
                    name: "writeoff_note",
                    label: "Write Off Note",
                    style: "width: 15%",
                    align: "left",
                    field: "note"
                },
                {
                    name: "item_billed_createdby",
                    label: "Write Off Created By",
                    style: "width: 15%",
                    align: "left",
                    format: (val, row) => {
                        if (row?.create_by.display_name) {
                            return row.create_by.display_name;
                        }
                        return "-";
                    }
                }
            ];
        },
        isLoading() {
            return this.loading.summary || this.loading.details;
        }
    }
};
</script>
